var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDockConfiguration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.550781 20.7H23.4508",
    stroke: "#55489E",
    strokeWidth: 1.9091,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99023 20.72V6.73999H22.0102V20.74",
    stroke: "#55489E",
    strokeWidth: 1.9091,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.19141 20.74V14.97H9.96141V20.74",
    stroke: "#55489E",
    strokeWidth: 1.9091,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.291 20.74V14.97H19.061V20.74",
    stroke: "#55489E",
    strokeWidth: 1.9091,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.85156 10.31H21.8516",
    stroke: "#55489E",
    strokeWidth: 1.9091,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85156 0.309998V6.31",
    stroke: "#55489E",
    strokeWidth: 1.9091,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85156 2.31V6.31",
    stroke: "#55489E",
    strokeWidth: 1.9091,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDockConfiguration);
export default __webpack_public_path__ + "static/media/dock-configuration.53b12ed7.svg";
export { ForwardRef as ReactComponent };